import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ZInput } from "@/components/ZInput";
import ZButton from "@/components/ZButton";
import Logo from "@/components/Logo";
import { AlertTriangle } from "lucide-react";

export default function ChangePasswordPage() {
  const { user, refreshUser } = useAuth();
  const nav = useNavigate();
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (p1.length < 6) return setErr("Mot de passe : 6 caractères minimum.");
    if (p1 !== p2) return setErr("Les mots de passe ne correspondent pas.");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { new_password: p1 });
      await refreshUser();
      if (user?.role === "agent") nav("/agent/scan");
      else if (user?.role === "organizer") nav("/org");
      else nav("/events");
    } catch (e) {
      setErr(errMsg(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="z-container" style={{ maxWidth: 460 }} data-testid="change-password-page">
      <div style={{ textAlign: "center", marginBottom: 24 }}>
        <Logo to={null} size={28} />
      </div>

      {user?.must_change_password && (
        <div style={{ background: "rgba(218,113,1,0.10)", color: "var(--z-orange)", padding: 14, borderRadius: 12, marginBottom: 18, display: "flex", gap: 10, alignItems: "flex-start" }} data-testid="must-change-banner">
          <AlertTriangle size={20} />
          <div style={{ fontSize: 14, fontWeight: 600 }}>
            Vous devez définir un nouveau mot de passe pour continuer.
          </div>
        </div>
      )}

      <h1 className="z-page-title">Nouveau mot de passe</h1>
      <p className="z-page-sub">Choisissez un mot de passe sécurisé (6 caractères minimum).</p>

      <form onSubmit={submit} className="z-card" style={{ padding: 24 }}>
        <ZInput
          type="password" label="Nouveau mot de passe" value={p1}
          onChange={(e) => setP1(e.target.value)} required minLength={6}
          data-testid="change-password-new"
        />
        <ZInput
          type="password" label="Confirmer" value={p2}
          onChange={(e) => setP2(e.target.value)} required minLength={6}
          data-testid="change-password-confirm"
        />
        {err && <p className="z-error-text" data-testid="change-password-error">{err}</p>}
        <ZButton type="submit" block loading={loading} data-testid="change-password-submit">
          Mettre à jour
        </ZButton>
      </form>
    </div>
  );
}
